import FeatureGates from '@atlaskit/feature-gate-js-client';
import { AidFrontendFeatureGate } from '../../providers/FeatureGates';
import { isFeatureGateProviderReady } from '../../providers/FeatureGateProvider';

export const checkFeatureGate = (key: AidFrontendFeatureGate) => {
  if (process.env.NODE_ENV === 'development' && !FeatureGates.initializeCompleted()) {
    console.warn(`Feature flag ${key} accessed before initialize completed`);
  }

  return FeatureGates.checkGate(key);
};

export const checkFeatureGateOnceInitialized = async (key: AidFrontendFeatureGate) => {
  await isFeatureGateProviderReady;
  if (process.env.NODE_ENV === 'development' && !FeatureGates.initializeCompleted()) {
    console.error(`Feature flag ${key} accessed before initialize completed`);
  }

  return FeatureGates.checkGate(key);
};
